import {
    DataLabelOptions,
    DonutWidth,
    InnerRadius,
    LegendOptions,
    MetricGroupOptions,
    NumberFormat,
} from '@sprinklr/stories/hyperspaceWidgets/types';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';

import { HyperSpacePieChartWidgetOptions } from './types';

export class HyperSpacePieChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpacePieChartWidgetOptions {
    @observable legend: LegendOptions = {
        enabled: true,
        position: {
            auto: true,
            selectedPosition: 'right',
        },
    };
    @observable innerRadius: InnerRadius = {
        enabled: false,
        size: null,
    };
    @observable donutWidth: DonutWidth = {
        enabled: false,
        size: null,
    };
    @observable dataLabelOptions: DataLabelOptions = {
        enabled: false,
        formats: {
            numberFormat: {
                decimals: 2,
                useShortened: true,
            },
        },
        fontSize: 10,
    };
    @observable metricGroupOptions: MetricGroupOptions = {
        enabled: true,
        metric: {
            size: 50,
            enabled: true,
            format: {
                decimals: 2,
                useShortened: true,
            },
        },
        metricName: {
            size: 25,
            enabled: true,
        },
        percentChange: {
            size: 20,
            enabled: false,
        },
    };
}
